import React from "react";
import "./App.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { WaveCanvas, SiteNav, SiteFooter } from "./Home";
import AidanRoutine from "./Videos/AidanRoutineWorld_2025";
const Photo1 =
  "/images/aidan-li-and-wajdi-bouallegue-2025-artistic-gymnastics-world-championships.png";
const Photo2 =
  "/images/aidan-li-and-wajdi-bouallegue-2025-artistic-gymnastics-world-championships-2.png";
const Photo3 =
  "/images/aidan-li-8th-pommel-horse-final-2025-world-championships.png";
const Photo4 =
  "/images/aidan-li-pommel-horse-2025-artistic-gymnastics-world-championships.png";
const Photo5 =
  "/images/aidan-li-pommel-horse-2025-artistic-gymnastics-world-championships-2.png";
const Photo6 =
  "/images/aidan-li-pommel-horse-2025-artistic-gymnastics-world-championships-3.png";
const Photo7 =
  "/images/aidan-li-pommel-horse-2025-artistic-gymnastics-world-championships-4.png";
const Photo8 =
  "/images/aidan-li-and-wajdi-bouallegue-2025-artistic-gymnastics-world-championships-3.png";

export default function NewsWorlds2025() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>
          Olympic Wave | Aidan Li - 2025 Artistic Gymnastics World Championships
        </title>
        <meta
          name="description"
          content="Full competition recap, performance results and photos of Aidan Li at the 2025 Artistic Gymnastics World Championships."
        />
        <meta
          property="og:title"
          content="Aidan Li - 2025 Artistic Gymnastics World Championships."
        />
        <meta
          property="og:description"
          content="See full competition recap and photos of Aidan Li at the 2025 Artistic Gymnastics World Championships."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://olympicwave.ca/news/aidan-li-2025-artistic-gymnastics-world-championships"
        />
      </Helmet>

      <WaveCanvas />
      <div className="ow-page">
        <SiteNav />

        <main className="ow-inner ow-article-inner">
          {/* Hero image */}
          <div className="ow-article-hero">
            <img
              src={Photo8}
              alt="Aidan Li and Wajdi Bouallègue at the 2025 Artistic Gymnastics World Championships"
            />
            <div className="ow-article-hero-overlay">
              <Link to="/news" className="ow-article-back-link">
                <ArrowLeft size={15} strokeWidth={2} /> {t("back")}
              </Link>
              <div className="ow-article-title-wrap">
                <h1 className="ow-article-title">{t("aiden_worlds")}</h1>
              </div>
            </div>
          </div>

          {/* Article body */}
          <div className="ow-article-body">
            {/* Row 1 — image left, text right, tall image */}
            <div className="ow-article-row">
              <div className="ow-article-img-wrap ow-img-tall">
                <img
                  src={Photo1}
                  alt="Aidan Li and Wajdi Bouallègue at the 2025 Artistic Gymnastics World Championships"
                />
              </div>
              <div className="ow-article-text">
                <h2 className="ow-article-section-title">
                  {t("world-title-1")}
                </h2>
                <p className="ow-article-p">{t("world-text-1")}</p>
              </div>
            </div>

            {/* Row 2 — full width centered */}
            <div className="ow-article-row-full">
              <div className="ow-article-img-wrap ow-img-narrow-tall">
                <img
                  src={Photo3}
                  alt="Aidan Li finished 8th in the pommel horse final at the 2025 World Championships"
                />
              </div>
              <div className="ow-article-text ow-text-center">
                <h2 className="ow-article-section-title">
                  {t("world-title-2")}
                </h2>
                <p className="ow-article-p">{t("world-text-2")}</p>
              </div>
            </div>

            {/* Row 3 — text left, image right */}
            <div className="ow-article-row">
              <div className="ow-article-text">
                <h2 className="ow-article-section-title">
                  {t("world-title-3")}
                </h2>
                <p className="ow-article-p">{t("world-text-3")}</p>
              </div>
              <div className="ow-article-img-wrap">
                <img
                  src={Photo2}
                  alt="Aidan Li and Wajdi Bouallègue at the 2025 Artistic Gymnastics World Championships"
                />
              </div>
            </div>

            {/* Routine video */}
            <div className="ow-article-media-block">
              <h2 className="ow-article-section-title-2">{t("routine")}</h2>
              <AidanRoutine />
            </div>

            {/* Photo gallery */}

            <div className="ow-article-media-block">
              <h2
                className="ow-article-section-title"
                style={{ marginTop: "2rem" }}
              >
                {t("morephoto")}
              </h2>
              <div className="ow-gallery-editorial-b">
                <div className="ow-gallery-b-feat">
                  <img
                    src={Photo5}
                    alt="Canadian gymnast Aidan Li at the 2025 World Championships"
                  />
                </div>
                <div className="ow-gallery-b-stack-item">
                  <img
                    src={Photo4}
                    alt="Aidan Li pommel horse 2025 World Championships"
                  />
                </div>
                <div className="ow-gallery-b-stack-item">
                  <img
                    src={Photo7}
                    alt="Aidan Li at the 2025 World Championships"
                  />
                </div>
                <div className="ow-gallery-b-bottom-left">
                  <img
                    src={Photo6}
                    alt="Aidan Li during competition 2025 World Championships"
                  />
                </div>
                <div className="ow-gallery-b-bottom-right">
                  <img
                    src={Photo8}
                    alt="Aidan Li and Wajdi Bouallègue at the 2025 Artistic Gymnastics World Championships"
                  />
                </div>
              </div>
            </div>
          </div>
        </main>

        <SiteFooter />
      </div>
    </>
  );
}
